var urls = {
  dev: 'https://dev-myprofile.web.s7.ru/auth',
  local: 'http://localhost:3002/auth',
  production: 'https://myprofile.s7.ru/auth',
  proxy: '/api/service',
  webapp: '/profile/api/service',
  qa: 'https://qa-myprofile.web.s7.ru/auth',
  stage: 'https://stage-myprofile.web.s7.ru/auth'
};
export default function stages(env) {
  if (typeof window !== 'undefined' && (env === 'proxy' || env === 'webapp')) {
    var _window = window,
        _window$location = _window.location,
        protocol = _window$location.protocol,
        hostname = _window$location.hostname,
        port = _window$location.port;
    return "".concat(protocol, "//").concat(hostname).concat(port ? ":".concat(port) : '').concat(urls[env]);
  }

  return urls[env] || urls.proxy;
}